import "./Auth.css";
import { Link, useLocation } from "react-router-dom";
import Logo from "../../Logo";
import { sendPasswordResetEmail } from "firebase/auth";
import { useRef, useState } from "react";
import { getAuth } from "firebase/auth";
import { app } from "../../../functions/firebaseInit";
import { useNavigate } from "react-router-dom";
import { initializeApp } from "firebase/app";

export default function ForgotPassword() {
    const auth = getAuth(initializeApp(app));
    const credentials = useRef();
    const [errorMessage, setErrorMessage] = useState("");
    const navigate = useNavigate();
    const location = useLocation();

    const resetPasswordEmail = () => {
        const email = credentials.current[0].value;

        setErrorMessage("");

        sendPasswordResetEmail(auth, email)
            .then(() => {
                alert("Email sent. Check your spam if it doesn't reach your inbox.");
                navigate("/signin", { replace: true });
            })
            .catch((e) => setErrorMessage(e.message));
    }

    return <div id="auth-container">
        <div id="form-title">
            <Logo />
            <h1>Forgot Password</h1>
        </div>
        <form className="auth-form" onSubmit={(e) => { e.preventDefault(); resetPasswordEmail(); }} ref={credentials}>

            <h3 id="auth-error">{errorMessage}</h3>

            <label htmlFor="email">Email</label>
            <input id="email" placeholder="Enter email" className="auth-input" />

            <input type="submit" value="Reset Password" className="auth-confirm" />

            <Link to="/signin" state={{ yourCup: location.state?.yourCup }}>Return to Sign In</Link>

        </form>

    </div>
}